<template>
	<AppLayout :title="trans('menu.events.register')">
		<Empty v-if="events.length === 0"/>
		<CardGrid v-else>
			<Card v-for="event in events" :title="event.title" :subtitle="event.subtitle" :image="event.image" has-image>
				<template #footer>
					<Link :as="SecondaryButton" :color="Color.Blue" :data-testid="`show-event-${event.id}-button`" :href="route('events.show', event.id)">
						<i class="fa-solid fa-eye mr-2"/>
						{{ trans('general.view') }}
					</Link>
				</template>
			</Card>
		</CardGrid>
	</AppLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Empty from '@/Components/Empty.vue'
import Card from '@/Components/Cards/Card.vue'
import {defineProps, ref, type Ref} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import {type Event} from '@/Types/Events/Event'
import CardGrid from '@/Components/Cards/CardGrid.vue'
import SecondaryButton from '@/Components/Buttons/SecondaryButton.vue'

const props = defineProps<{
	events: Array<Event>,
}>()

const events: Ref<Array<Event>> = ref(props.events)
</script>